<template>
<div>
    <div class="row justify-content-center">
        <div class="col-sm-6 more-top-padding">
            <label for="purchaseOrderNumber">Purchase Order Number</label>
                <base-input id="purchaseOrderNumber" :disabled="isReadOnly || isPartnerAccount" v-model="financeInfo.purchaseNumber" name="purchaseOrderNumber" v-validate="'required'"
          :error="getError('purchaseOrderNumber')" data-vv-as="Purchase Order Number">
                </base-input>
        </div>
        <div class="col-sm-6 more-top-padding">
            <label for="invoiceNumber">Invoice Number</label>
                <base-input id="invoiceNumber" :disabled="isReadOnly || isPartnerAccount" v-model="financeInfo.invoiceNumber" name="invoiceNumber" v-validate="'required'"
          :error="getError('invoiceNumber')" data-vv-as="Invoice Number">
                </base-input>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-sm-12 more-top-padding">
            <div class="pull-right">
                <base-button type="primary" :disabled="isReadOnly || isPartnerAccount" wide @click.native="submit" class="btn-next">Save</base-button>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import Utility from "@/mixins/utility/utility";

export default {
    props: ["isReadOnly"],
    name: "FinanceInformation",
    mixins: [Utility],
    data() {
        return {};
    },
    components: {},
    computed: {
        ...mapGetters({
            financeInfo: "financeInformation/financeInfo",
            financeInfoErrors: "financeInformation/financeInfoErrors",
            isPartnerAccount: "authentication/isPartnerAccount"
        }),
        getOrderIdFromRoute() {
            return parseInt(this.$route.params.id);
        },
    },
    methods: {
        ...mapActions({
            loadFinanceInformation: "financeInformation/loadFinanceInformation",
            getFinanceInformationStatus: "financeInformation/getFinanceInformationStatus",
            saveFinanceInfoToServer: "financeInformation/saveFinanceInfoToServer"
        }),
        loaded() {
            this.loadFinanceInformation(this.getOrderIdFromRoute);
            this.getFinanceInformationStatus(this.getOrderIdFromRoute);
        },
        showFinanceInfoErrors () {
      if(this.financeInfoErrors.length > 0 ) {
            this.financeInfoErrors.forEach(error => this.$toast.error(error))
        }
    },
        async submit(e) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    let ctx = this;
                    this.saveFinanceInfoToServer(this.getOrderIdFromRoute)
                        .then(() => {
                            ctx.getFinanceInformationStatus(ctx.getOrderIdFromRoute).then(() => {
                                ctx.showFinanceInfoErrors();
                            });
                            ctx.loadFinanceInformation(this.getOrderIdFromRoute);
                        });
                } else {
                    this.$toast.error("Please fill the form required fields.");
                }
            });
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
    },
};
</script>

<style>
@import "../../../../../../client-app/public/AGATRS.css";
</style>
